import React from 'react'

// Types 
import { EmailValidatorProps } from '../types'

// Validators
import { validateEmail } from '../validators'

// Components 
import Validator from './Validator'

const EmailValidator: React.FC<EmailValidatorProps> = (props) => {

    const { value, required, equals } = props

    const validate = () => {
        return validateEmail(value, {required, equals}) 
    }

    return <Validator {...props} validate={validate} />

}

export default EmailValidator